"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkEmail = checkEmail;
var _flow = require("../../types/flow");
var _authentication = require("../../types/authentication");
var _action_types = require("../../constants/action_types");
var _events = require("../../types/events");
var _isEmailRegistered = require("../../api/isEmailRegistered");
var _flow2 = require("../flow");
var _view = require("../view");
var _tracking = require("../../utils/tracking");
var _view2 = require("../../types/view");
function checkEmail() {
  return async (dispatch, getState, context) => {
    dispatch({
      type: _action_types.AUTHENTICATION_CHECK_EMAIL_TYPE,
      status: _authentication.ECheckEmailStatus.Loading
    });
    const {
      login,
      view,
      source
    } = getState();
    try {
      const res = await (0, _isEmailRegistered.isEmailRegistered)(context.httpApi, {
        email: login
      });
      if (res.statusCode === 200) {
        const {
          isRegistered
        } = res.response;
        dispatch({
          type: _action_types.AUTHENTICATION_CHECK_EMAIL_TYPE,
          status: _authentication.ECheckEmailStatus.Succeed
        });
        context.emitter.emit(_events.EEventType.EmailChecked, {
          isRegistered
        });
        if (isRegistered) {
          dispatch((0, _flow2.changeFlow)(_flow.EActiveFlow.Authentication));
          (0, _tracking.trackShowTwoStepPassword)('email', source);
        } else {
          dispatch((0, _view.changeView)(_view2.EActiveView.Agreement, {
            prevView: view.active,
            prevData: view.data,
            email: login
          }));
        }
      } else {
        dispatch({
          type: _action_types.AUTHENTICATION_CHECK_EMAIL_TYPE,
          status: _authentication.ECheckEmailStatus.Failed,
          errorType: _authentication.ECheckEmailError.LimitReached,
          error: 'Превышен лимит попыток авторизации. Попробуйте позже'
        });
      }
    } catch (e) {
      context.logger.error(e, {
        domain: 'auth-widget.api.checkEmail'
      });
      dispatch({
        type: _action_types.AUTHENTICATION_CHECK_EMAIL_TYPE,
        status: _authentication.ECheckEmailStatus.Failed,
        errorType: _authentication.ECheckEmailError.Unexpected,
        error: 'Произошла непредвиденная ошибка'
      });
    }
  };
}